'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Common Errors
 */

var AXIOS_ERROR = exports.AXIOS_ERROR = 'x001';
var LANGUAGE_NOT_FOUND = exports.LANGUAGE_NOT_FOUND = 'x010';
var MAILER_ERROR = exports.MAILER_ERROR = 'x011';
var MAILER_OPTIONS_ERROR = exports.MAILER_OPTIONS_ERROR = 'x012';
/**
 * Authorization Errors
 */

var AUTHORIZATION_BAD_HEADER = exports.AUTHORIZATION_BAD_HEADER = 'x100';
var AUTHORIZATION_JWT_ERROR = exports.AUTHORIZATION_JWT_ERROR = 'x110';
/**
 * Users Errors
 */

var USER_VALIDATION = exports.USER_VALIDATION = 'x200';
var USER_NOT_ACTIVE = exports.USER_NOT_ACTIVE = 'x205';
var USER_PASSWORD_VALIDATION = exports.USER_PASSWORD_VALIDATION = 'x210';
var USER_STATUS_VALIDATION = exports.USER_STATUS_VALIDATION = 'x220';
var USER_ROL_VALIDATION = exports.USER_ROL_VALIDATION = 'x230';
var USER_NOT_PERMISSION = exports.USER_NOT_PERMISSION = 'x240';
var USER_ALREADY_EXISTS = exports.USER_ALREADY_EXISTS = 'x250';
var USER_NOT_FOUND = exports.USER_NOT_FOUND = 'x260';
var USER_PASSWORD_TOKEN_VALIDATION = exports.USER_PASSWORD_TOKEN_VALIDATION = 'x270';
var USER_ACTIVATION_TOKEN_VALIDATION = exports.USER_ACTIVATION_TOKEN_VALIDATION = 'x275';
/**
 * Company Data
 */

var COMPANY_NOT_FOUND = exports.COMPANY_NOT_FOUND = 'x300';
var ACTIVITY_NOT_FOUND = exports.ACTIVITY_NOT_FOUND = 'x310';
/**
 * Evaluation
 */

var EVALUATION_VALIDATION = exports.EVALUATION_VALIDATION = 'x350';
var EVALUATION_INVALID_STATUS = exports.EVALUATION_INVALID_STATUS = 'x351';
var EVALUATION_STATUS_VALIDATION = exports.EVALUATION_STATUS_VALIDATION = 'x355';
var EVALUATION_NOT_FOUND = exports.EVALUATION_NOT_FOUND = 'x360';
var EVALUATION_USER_NOT_ATTACHED = exports.EVALUATION_USER_NOT_ATTACHED = 'x370';
var EVALUATION_STATUS_USER_NOT_ALLOWED = exports.EVALUATION_STATUS_USER_NOT_ALLOWED = 'x375';
var EVALUATION_ALREADY_REJECTED = exports.EVALUATION_ALREADY_REJECTED = 'x380';
/**
 * Refocal
 */

var REFOCAL_QUESTIONS_NOT_FOUND = exports.REFOCAL_QUESTIONS_NOT_FOUND = 'x400';
var REFOCAL_API_ERROR = exports.REFOCAL_API_ERROR = 'x410';
/**
 * Database Errors
 */

var DATABASE_ERROR = exports.DATABASE_ERROR = 'x500';
/**
 * Hacienda
 */

var HACIENDA_BAD_REQUEST = exports.HACIENDA_BAD_REQUEST = 'x5000';
var HACIENDA_READ_PDF_ERROR = exports.HACIENDA_READ_PDF_ERROR = 'x5001';
var HACIENDA_VALIDATION_ERROR = exports.HACIENDA_VALIDATION_ERROR = 'x5002';
var HACIENDA_RULE_EXTRACTOR = exports.HACIENDA_RULE_EXTRACTOR = 'x5003';
var HACIENDA_BLOCKED_REQUEST = exports.HACIENDA_BLOCKED_REQUEST = 'x5004';
var HACIENDA_VALIDATION_ERROR_NIF = exports.HACIENDA_VALIDATION_ERROR_NIF = 'x5010';
var HACIENDA_VALIDATION_ERROR_MODEL = exports.HACIENDA_VALIDATION_ERROR_MODEL = 'x5011';
var HACIENDA_VALIDATION_ERROR_PERIOD = exports.HACIENDA_VALIDATION_ERROR_PERIOD = 'x5012';
/**
 * Not Implemented
 */

var NOT_IMPLEMENTED_ERROR = exports.NOT_IMPLEMENTED_ERROR = 'x999';